// @ts-check
import React from 'react';
import config from '../../config';
import InputContainer from './InputContainer';
import Link from './Link';

import './LoginButton.scss';

function initPx() {
	const appIds = {
		PROD: 'PX9ei9r7cY',
		QA: 'PXgfYE8064',
		DEV: 'PXOZw87cz0',
	};

	const appId = appIds[config.Environment];

	window['_pxAppId'] = appId;

	// Custom parameters
	// window._pxParam1 = "<param1>";

	const p = document.getElementsByTagName('script')[0];
	const s = document.createElement('script');

	s.async = true;
	s.src = `//client.px-cloud.net/${appId}/main.min.js`;

	p.parentNode.insertBefore(s, p);
}

/**
 * @typedef LoginFormPersonalBankingProps
 * @property {import('~/templates/hero/PageHeroLoginForm').PageHeroLoginFormOptionsWith$} options
 */
/** @type {import('~/types/React').ReactFC<LoginFormPersonalBankingProps>} */
const LoginFormPersonalBanking = ({ options }) => {
	const initialState = {
		userId: '',
		password: '',
	};
	const [state, setState] = React.useState(initialState);

	React.useEffect(() => {
		initPx();
	}, []);

	return (
		<form name="personal_form" id="personal_form" action={config.HubEnv} method="POST">
			<InputContainer icon="person">
				<label htmlFor="LoginName" tabIndex={-1}>
					{options.username_placeholder}
				</label>
				<input
					type="text"
					name="LoginName"
					aria-label="User Id"
					autoComplete="off"
					value={state.userId}
					onChange={(e) => setState({ ...state, userId: e.target.value })}
					{...options.$?.username_placeholder}
				/>
			</InputContainer>
			<InputContainer icon="lock">
				<label htmlFor="Password" tabIndex={-1}>
					{options.password_placeholder}
				</label>
				<input
					type="password"
					name="Password"
					aria-label="Password"
					autoComplete="off"
					value={state.password}
					onChange={(e) => setState({ ...state, password: e.target.value })}
					{...options.$?.password_placeholder}
				/>
			</InputContainer>
			<button className="login-button btn" id="Personal_Hero_Card_Login_Button" {...options.$?.button_text}>
				{options.button_text ?? 'Login'}
			</button>
			<div style={{ textAlign: 'center', paddingTop: '0.5rem', paddingBottom: '1rem' }}>
				<>
					{!!options?.links?.[0] && (
						<Link to={options.links[0].link_url} {...options.links[0].$?.link_url}>
							{options.links[0].link_text}
						</Link>
					)}
					{!!options?.links?.[1] && (
						<>
							<span> | </span>
							<Link to={options.links[1].link_url} {...options.links[1].$?.link_url}>
								{options.links[1].link_text}
							</Link>
						</>
					)}
				</>
			</div>
		</form>
	);
};

export default LoginFormPersonalBanking;
